import React, { useEffect, useMemo, useState } from 'react'
import { ModalWrapper, StyledButton, TextFields } from '../../../../../../components'
import { Avatar, Box, Typography } from '@mui/material'
import { SuccesAnimation } from '../../../../../../assets/images'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { useDispatch, useSelector } from 'react-redux'
import { useGlobal, usePostApi } from '../../../../../../shared'
import { baseURL, urls } from '../../../../../../shared/config'
import { toast } from 'react-toastify'
import {
  setAnchorEl,
  setLoader,
  setRefreshPage,
  setSelectedRow,
} from '../../../../../../redux/globalSlice'
import { formatDate } from '../../../../../../components/Table/TableCells/TableCell'
import { ImportIcon } from '../../../../../../assets/icons'

import { useRef } from 'react'
import html2canvas from 'html2canvas'
import jsPDF from 'jspdf'
import Report from './FeeReport'
import classes from './FeeInfo.module.css'
import axios from 'axios'

export const FeeInfo = ({ open, handleClose, month }) => {
  const dispatch = useDispatch()
  const studentID = useSelector((state) => state.global.studentID)
  const rowData = useSelector((state) => state.global.SchoolDInfo)

  const selectedMonth = rowData?.month ?? month

  const { data: feeDetail } = useGlobal({
    userUrl: `${urls.FEE_DETAIL}${studentID}&month=${selectedMonth}`,
  })

  const studentInfo = feeDetail && feeDetail?.studentDetail
  const feeInfo = feeDetail && feeDetail?.feeInvoice

  const payments = feeInfo && feeInfo[0] && feeInfo[0]?.payments

  const reportRef = useRef(null)
  // const handleGeneratePdf = async () => {
  //   dispatch(setLoader(true))
  //   const input = reportRef.current
  //   try {
  //     const canvas = await html2canvas(input, {
  //       scale: 5,
  //       logging: false,
  //       scrollY: -window.scrollY,
  //       windowWidth: document.documentElement.offsetWidth,
  //       windowHeight: document.documentElement.offsetHeight,
  //       useCORS: true,
  //     })

  //     const imgHeight = canvas.height
  //     const imgWidth = canvas.width
  //     const pdf = new jsPDF('p', 'px', 'a4')

  //     const pageWidth = pdf.internal.pageSize.getWidth()
  //     const pageHeight = pdf.internal.pageSize.getHeight()

  //     const ratio = pageWidth / imgWidth
  //     const scaledHeight = imgHeight * ratio

  //     // let position = 0
  //     let pageCanvas = document.createElement('canvas')
  //     let pageCtx = pageCanvas.getContext('2d')

  //     const totalPages = Math.ceil(scaledHeight / pageHeight)

  //     for (let page = 0; page < totalPages; page++) {
  //       const startY = page * (canvas.height / totalPages)
  //       const pageHeightInCanvas = canvas.height / totalPages

  //       pageCanvas.width = canvas.width
  //       pageCanvas.height = pageHeightInCanvas

  //       pageCtx.clearRect(0, 0, canvas.width, pageHeightInCanvas)
  //       pageCtx.drawImage(canvas, 0, -startY)

  //       const imgData = pageCanvas.toDataURL('image/png')
  //       if (page > 0) pdf.addPage()
  //       pdf.addImage(imgData, 'PNG', 0, 0, pageWidth, pageHeight)
  //     }

  //     pdf.save(`${studentInfo?.student_name}_invoice.pdf`)
  //     dispatch(setLoader(false))
  //   } catch (error) {
  //     console.error('Error Generating Pdf:', error)
  //     toast.error('Error Generating Pdf')
  //     dispatch(setLoader(false))
  //   }
  // }
  // const handleGeneratePdf = async () => {
  //   dispatch(setLoader(true))
  //   const input = reportRef.current
  //   try {
  //     const canvas = await html2canvas(input, {
  //       scale: 5,
  //       logging: false,
  //       scrollY: -window.scrollY,
  //       windowWidth: document.documentElement.offsetWidth,
  //       windowHeight: document.documentElement.offsetHeight,
  //       useCORS: true,
  //     })
  //     const imgData = canvas.toDataURL('route')
  //     const pdf = new jsPDF({
  //       orientation: 'portrait',
  //       unit: 'px',
  //       format: 'a4',
  //     })

  //     const width = pdf.internal.pageSize.getWidth()
  //     const height = (canvas.height * width) / canvas.width
  //     pdf.addImage(imgData, 'PNG', 0, 0, width, height)
  //     pdf.save(`${studentInfo?.student_name}_invoice.pdf`)
  //     dispatch(setLoader(false))
  //   } catch (error) {
  //     console.error('Error Generating Pdf:', error)
  //     toast.error('Error Generating Pdf')
  //     dispatch(setLoader(false))
  //   }
  // }
  const handleGeneratePdf = async () => {
    dispatch(setLoader(true))
    const input = reportRef.current
    try {
      const canvas = await html2canvas(input, {
        scale: 2,
        logging: false,
        scrollY: -window.scrollY,
        windowWidth: document.documentElement.offsetWidth,
        windowHeight: document.documentElement.offsetHeight,
        useCORS: true,
      })
      const imgData = canvas.toDataURL('image/png')
      const pdf = new jsPDF({
        orientation: 'portrait',
        unit: 'px',
        format: 'a4',
      })

      const width = pdf.internal.pageSize.getWidth()
      const height = (canvas.height * width) / canvas.width

      let contentHeight = height
      let offsetY = 0

      // Add the first page
      pdf.addImage(imgData, 'PNG', 0, offsetY, width, height)

      // If content height is greater than the page size, continue adding pages
      while (contentHeight > pdf.internal.pageSize.height) {
        offsetY = -pdf.internal.pageSize.height
        contentHeight -= pdf.internal.pageSize.height
        pdf.addPage()
        pdf.addImage(imgData, 'PNG', 0, offsetY, width, height)
      }

      // Save the PDF
      pdf.save(`${studentInfo?.student_name}_invoice.pdf`)
      dispatch(setLoader(false))
    } catch (error) {
      console.error('Error Generating Pdf:', error)
      toast.error('Error Generating Pdf')
      dispatch(setLoader(false))
    }
  }

  const handleModalClose = () => {
    dispatch(setAnchorEl(null))
    dispatch(setSelectedRow([]))
    handleClose()
  }

  return (
    <ModalWrapper fees={true} open={open} handleClose={handleModalClose} width={'513px'}>
      <div>
        <div className={classes.modalTop}>
          <div
            style={{
              padding: '0px',
            }}
            className="fee-head"
          >
            <img
              src={SuccesAnimation}
              alt=""
              style={{
                width: '100px',
                height: '100px',
              }}
            />
            <Typography fontWeight={700} mb={0} mt={4} fontSize={'24px'}>
              Fees Collected
            </Typography>
            <Typography mt={1} fontSize={'16px'}>
              {`The student's fees have been collected. Thank you! Please find the PDF receipt attached.`}
            </Typography>
          </div>
          <Box p={0}>
            <Typography mt={4} mb={0} className="grey-text" fontSize={'14px'} textAlign={'left'}>
              FEES INFORMATION
            </Typography>
            <Box mt={'12px'} className="fee-container">
              <Typography mb={2} className="fees-i-titles">
                STUDENT
              </Typography>
              <div className="fees-inner-info">
                <FeeContent title={'Student Name'} value={studentInfo?.student_name} />
                <FeeContent
                  title={'Registration Number'}
                  value={studentInfo?.student_registration_number}
                />
                <FeeContent title={'Father Name'} value={studentInfo?.student_father_name} />
              </div>
              <Typography mt={2} className="fees-i-titles">
                FEES
              </Typography>
              {feeInfo?.map((fee, index) => (
                <Box mt={2} className="fees-inner-info" key={index}>
                  <FeeContent title={'Payment ID'} value={`${fee?.payment_id}`} />
                  <FeeContent title={'Payment Month'} value={`${fee?.payment_month}`} />
                  <FeeContent
                    title={'Payment Tuition Fee'}
                    value={`₹${fee?.payment_tuition_fee}`}
                  />
                  <FeeContent
                    title={'Payment Transport Fee'}
                    value={`₹${fee?.payment_transport_fee}`}
                  />
                  <FeeContent
                    title={'Payment Monthly Discount'}
                    value={`₹${fee?.payment_monthly_discount}`}
                  />
                  <FeeContent title={'Payment Misc Fee'} value={`₹${fee?.payment_misc_fee}`} />
                  <FeeContent
                    title={'Payment Last Year Due Fee'}
                    value={`₹${fee?.payment_last_year_due_fee}`}
                  />
                  <FeeContent title={'Payment Exam Fee'} value={`₹${fee?.payment_exam_fee}`} />
                  {/* <FeeContent title={'Payment Tuition Fee'} value={`₹${fee?.payment_tuition_fee}`} />
                <FeeContent title={'Payment Tuition Fee'} value={`₹${fee?.payment_tuition_fee}`} /> */}
                  <FeeContent title={'Date'} value={formatDate(fee?.createdAt)} />
                </Box>
              ))}
            </Box>
          </Box>
        </div>

        <Buttons onDownload={handleGeneratePdf} onSubmit={handleModalClose} />
        <div style={{ position: 'absolute', left: '-9999px' }}>
          <div ref={reportRef}>
            <Report feeInfo={feeInfo} payments={payments} studentInfo={studentInfo} />
          </div>
        </div>
      </div>
    </ModalWrapper>
  )
}
const FeeContent = ({ title, value }) => {
  return (
    <div className="fees-i-item">
      <Typography className="fee-i-title">{title}</Typography>
      <Typography fontSize={'15px'} fontWeight={500}>
        {value}
      </Typography>
    </div>
  )
}
const Buttons = ({ onSubmit, onDownload }) => {
  return (
    <div
      className="in-a-row"
      style={{ justifyContent: 'center', padding: '16px 32px', borderTop: '1px solid #F2F4F7' }}
    >
      <Typography
        sx={{
          padding: '18px 24px',
          height: '56px',
        }}
        className="back-btn"
        onClick={onDownload}
      >
        <img src={ImportIcon} alt="" /> Download PDF
      </Typography>

      <StyledButton width={'50%'} onClick={onSubmit}>
        Done
      </StyledButton>
    </div>
  )
}

// export const StudentFee = ({ month, open, handleClose, individualfees, userSchoolId, refetch }) => {
//   const dispatch = useDispatch()
//   const { postApi } = usePostApi()
//   const SchoolDInfo = useSelector((state) => state.global.SchoolDInfo)

//   const studentID = useSelector((state) => state.global.studentID)
//   const rowData = useSelector((state) => state.global.SchoolDInfo)
//   const { data: feeDetail } = useGlobal({ userUrl: `${urls.FEE_DETAIL}${studentID}` })
//   // console.log('---------feedetail', feeDetail)
//   const school_fee_method = localStorage.getItem('school_fee_method')

//   const studentInfo = feeDetail && feeDetail?.studentDetail
//   // const selected = useSelector((state) => state.global.selectedRow)
//   const { data: Data } = useGlobal({
//     userUrl: `${urls.INDIVIDUAL_STUDENT_FEES}${studentID}&fee_method=${school_fee_method}`,
//   })
//   const [paidExamFeeSum, setPaidExamFeeSum] = useState(0)

//   const selectedMonthData = Data?.find((item) => item?.month === (rowData?.month || month))

//   console.log('---selectedMonthData',selectedMonthData);

//   // const feeID = feeDetail && feeDetail?.feeInvoice
//   // const feesID = feeID && feeID[0]?.fee_id
//   // const [feeStatus, setFeeStatus] = useState('Partial Payment')
//   // useEffect(() => {
//   //   if (individualfees && Data?.length > 0) {
//   //     const monthsOrder = [
//   //       'April',
//   //       'May',
//   //       'June',
//   //       'July',
//   //       'August',
//   //       'September',
//   //       'October',
//   //       'November',
//   //       'December',
//   //       'January',
//   //       'February',
//   //       'March',
//   //     ]

//   //     const selectedMonthName = month || rowData?.month
//   //     const selectedMonthIndex = monthsOrder.indexOf(selectedMonthName)

//   //     let totalPaidExamFee = 0

//   //     if (selectedMonthIndex === 0) {
//   //       // It's the first month (April)
//   //       const selectedData = Data.find((item) => item.month === selectedMonthName)
//   //       totalPaidExamFee = selectedData?.paid_exam_fee || 0
//   //     } else {
//   //       // Sum all previous months
//   //       totalPaidExamFee = Data.filter(
//   //         (item) => monthsOrder.indexOf(item.month) < selectedMonthIndex,
//   //       ).reduce((sum, item) => sum + (item.paid_exam_fee || 0), 0)
//   //     }

//   //     console.log('Calculated Paid Exam Fee:', totalPaidExamFee)
//   //     setPaidExamFeeSum(totalPaidExamFee)
//   //     // Optionally store in state if needed
//   //   }
//   // }, [individualfees, Data, month, rowData])
//   useEffect(() => {
//     if (individualfees && Data?.length > 0) {
//       const totalPaidExamFee = Data.reduce((sum, item) => {
//         return sum + (item.paid_exam_fee || 0)
//       }, 0)

//       console.log('Total Paid Exam Fee (All Months):', totalPaidExamFee)
//       setPaidExamFeeSum(totalPaidExamFee)
//     }
//   }, [individualfees, Data])
//   const validationSchema = Yup.object().shape({
//     paymentID: Yup.string().required('Payment ID is required'),
//     tuition_fee: Yup.number().required('Tuition Fee is required'),
//   })
//   const handleSubmit = () => {
//     dispatch(setLoader(true))
//     validationSchema
//       .validate(formik.values, { abortEarly: false })
//       .then(() => {
//         const responseBody = {
//           school_id: userSchoolId,
//           student_id: studentID,
//           last_year_due_fee: formik.values.last_year_due_fee,
//           transport_fee: formik.values.transportFee,
//           misc_fee: formik.values.miscFee,
//           exam_fee: formik.values.exam_fee,
//           tuition_fee: formik.values.tuition_fee,
//           month: month ? month : rowData?.month,
//           // fee_type: feeStatus,
//           payment_id: formik.values.paymentID,
//           monthly_discount: 0,
//           batch_year:SchoolDInfo?.student_batch_year
//         }
//         postApi(urls.ADD_FEE, responseBody)
//           .then((response) => {
//             if (response.status == 201 || response.status == 200) {
//               toast.success('Fee Added Successfully!')
//               dispatch(setLoader(false))
//               dispatch(setRefreshPage(true))
//               handleModalClose()
//               refetch()
//             } else {
//               toast.error(response.message)
//               dispatch(setLoader(false))
//               refetch()
//             }
//           })
//           .catch(() => {
//             toast.error('Error occurred while submitting')
//             dispatch(setLoader(false))
//             refetch()
//           })
//       })
//       .catch((errors) => {
//         if (errors instanceof Yup.ValidationError) {
//           errors.inner.forEach((err) => {
//             toast.error(err.message)
//           })
//         }
//         dispatch(setLoader(false))
//         refetch()
//       })
//   }

//   const formik = useFormik({
//     initialValues: {
//       transportFee: 0,
//       miscFee: 0,
//       tuition_fee: 0,
//       last_year_due_fee: 0,
//       monthly_discount: 0,
//       exam_fee: 0,
//       paymentID: '',
//     },
//     validationSchema: validationSchema,
//     onSubmit: handleSubmit,
//   })

//   // const handlefeeChange = (value) => {
//   //   setFeeStatus(value)
//   // }
//   const handleInputChange = (fieldName) => (e) => {
//     const numericValue = e.target.value.replace(/[^0-9]/g, '')
//     formik.setFieldValue(fieldName, numericValue)
//   }
//   const handleModalClose = () => {
//     dispatch(setSelectedRow([]))
//     handleClose()
//   }

//   return (
//     <ModalWrapper
//       open={open}
//       handleClose={handleModalClose}
//       width={'471px'}
//       title={'Confirmation'}
//       subtxt={
//         'Are you sure you want to collect the fees from the student? Please confirm to proceed.'
//       }
//     >
//       <div>
//         <Box mt={2}>
//           <div
//             style={{
//               display: 'flex',
//               alignContent: 'center',
//               justifyContent: 'space-between',
//               width: '100%',
//             }}
//           >
//             <Typography fontSize={'18px'} fontWeight={700}>
//               Student&apos;s Fees
//             </Typography>
//             <Typography
//               sx={{
//                 color: 'var(--Primary-500, #3C45FF)',
//                 fontFamily: 'Satoshi',
//                 fontSize: '16px',
//                 fontWeight: 500,
//                 letterSpacing: '0.32px',
//                 mb: 1,
//               }}
//             >
//               {month}
//             </Typography>
//           </div>

//           <div className="school-info fee-single-info" style={{ marginTop: '10px' }}>
//             <Avatar
//               alt={''}
//               sx={{ width: '36px', height: '36px', backgroundColor: '#F2ECF9', color: '#492972' }}
//             >
//               {studentInfo?.student_name?.[0]?.toUpperCase()}
//             </Avatar>
//             <div className="row-item">
//               <div>
//                 <Typography fontWeight={600}>{studentInfo?.student_name}</Typography>
//                 <Typography sx={{ color: '#98A1B2', fontSize: '12px' }}>
//                   Class: {selectedMonthData?.student_grade} - {selectedMonthData?.student_section}
//                 </Typography>
//               </div>
//               <Typography sx={{ color: '#039754', fontSize: '16px' }}>
//                 ₹
//                 {selectedMonthData?.fee_balance !== undefined
//                   ? (individualfees
//                       ? parseFloat(selectedMonthData.fee_balance) +
//                         (selectedMonthData?.student_exam_fee - paidExamFeeSum)
//                       : parseFloat(selectedMonthData.fee_balance) +
//                         (selectedMonthData.student_exam_fee - selectedMonthData.paid_exam_fee)
//                     )?.toFixed(2)
//                   : '0.00'}
//               </Typography>
//             </div>
//           </div>
//         </Box>

//         <div className="text-fields">
//           <TextFields
//             label={'Payment ID'}
//             width={'100%'}
//             required
//             placeholder={'Pay123'}
//             name={'paymentID'}
//             value={formik.values.paymentID}
//             onChange={formik.handleChange}
//           />
//           <TextFields
//             label={'Tuition Fee'}
//             required
//             width={'100%'}
//             name={'tuition_fee'}
//             value={formik.values.tuition_fee}
//             onChange={handleInputChange('tuition_fee')}
//           />
//         </div>

//         <div className="text-fields">
//           <TextFields
//             label={
//               individualfees
//                 ? `Exam Fee (Balance: ${selectedMonthData?.student_exam_fee - paidExamFeeSum || 0})`
//                 : `Exam Fee (Balance: ${selectedMonthData?.student_exam_fee - selectedMonthData?.paid_exam_fee || 0})`
//             }
//             width={'100%'}
//             name={'exam_fee'}
//             value={formik.values.exam_fee}
//             onChange={handleInputChange('exam_fee')}
//           />
//           <TextFields
//             label={'Last Year Due'}
//             width={'100%'}
//             name={'last_year_due_fee'}
//             value={formik.values.last_year_due_fee}
//             onChange={handleInputChange('last_year_due_fee')}
//           />
//         </div>

//         <div className="text-fields">
//           <TextFields
//             label={`Transport Fee:Balance(${selectedMonthData?.student_transport_fee})`}
//             width={'100%'}
//             name={'transportFee'}
//             value={formik.values.transportFee}
//             onChange={handleInputChange('transportFee')}
//           />
//           <TextFields
//             label={'Misc Fee'}
//             width={'100%'}
//             name={'miscFee'}
//             value={formik.values.miscFee}
//             onChange={handleInputChange('miscFee')}
//           />
//         </div>

//         <div className="in-a-row" style={{ justifyContent: 'flex-end' }}>
//           <Typography className="back-btn" onClick={handleModalClose}>
//             Cancel
//           </Typography>
//           <StyledButton width={'40%'} onClick={handleSubmit}>
//             Collect Fee
//           </StyledButton>
//         </div>
//       </div>
//     </ModalWrapper>
//   )
// }

export const StudentFee = ({
  month,
  open,
  handleClose,
  individualfees = false,
  userSchoolId,
  refetch,
}) => {
  const dispatch = useDispatch()
  const { postApi } = usePostApi()

  const SchoolDInfo = useSelector((state) => state.global.SchoolDInfo)

  const studentID = useSelector((state) => state.global.studentID)
  const rowData = useSelector((state) => state.global.SchoolDInfo)

  // console.log('----SchoolDInfo',rowData);

  const { data: feeDetail } = useGlobal({ userUrl: `${urls.FEE_DETAIL}${studentID}` })

  const school_fee_method = localStorage.getItem('school_fee_method')

  const { data: monthlyData } = useGlobal({
    userUrl: `${urls.INDIVIDUAL_STUDENT_FEES}${studentID}&fee_method=${school_fee_method}`,
  })

  const studentInfo = feeDetail?.studentDetail || {}

  // console.log('----monthlyData', monthlyData)

  const [paidExamFeeSum, setPaidExamFeeSum] = useState(0)

  const selectedMonthData =
    monthlyData?.find((item) => item?.month === (rowData?.month || month)) || {}

  const isAnually = school_fee_method === 'Annually'

  const mappedData = school_fee_method === 'Annually' ? monthlyData?.[0] : selectedMonthData

  // console.log('----mappedData', mappedData)

  const tuitionBalance = useMemo(() => {
    const totalTuition = isAnually
      ? Number(mappedData?.student_total_tuition_fee) || 0
      : Number(mappedData?.student_monthly_tuition_fee) || 0
    const paidTuition = Number(mappedData?.paid_tuition_fee) || 0
    return totalTuition - paidTuition
  }, [mappedData, isAnually])
  useEffect(() => {
    if (!individualfees || !Array.isArray(monthlyData) || monthlyData.length === 0) return

    const total = monthlyData.reduce((sum, item) => {
      return sum + (Number(item.paid_exam_fee) || 0)
    }, 0)

    setPaidExamFeeSum(total)
  }, [individualfees, monthlyData])

  // ────────────────────────────────────────────────
  // Formik setup – must come BEFORE any usage of formik.values
  // ────────────────────────────────────────────────
  const validationSchema = Yup.object().shape({
    paymentID: Yup.string().required('Payment ID is required'),
    tuition_fee: Yup.number().required('Tuition Fee is required'),
  })

  const formik = useFormik({
    initialValues: {
      transportFee: 0,
      miscFee: 0,
      tuition_fee: 0,
      last_year_due_fee: 0,
      monthly_discount: 0,
      exam_fee: 0,
      paymentID: '',
    },
    validationSchema,
    onSubmit: () => {
      // Handled in handleSubmit below
    },
  })

  // ────────────────────────────────────────────────
  // Calculations using formik.values – now safe
  // ────────────────────────────────────────────────
  const totalEntered = useMemo(() => {
    return (
      Number(formik.values.tuition_fee || 0) +
      Number(formik.values.transportFee || 0) +
      Number(formik.values.miscFee || 0) +
      Number(formik.values.exam_fee || 0) +
      Number(formik.values.last_year_due_fee || 0) +
      Number(formik.values.monthly_discount || 0)
    )
  }, [
    formik.values.tuition_fee,
    formik.values.transportFee,
    formik.values.miscFee,
    formik.values.exam_fee,
    formik.values.last_year_due_fee,
    formik.values.monthly_discount,
  ])

  // console.log('---mapped_data', mappedData)

  const remainingBalance = useMemo(() => {
    // Tuition base
    let baseTuitionFee = 0
    if (isAnually) {
      baseTuitionFee = Number(mappedData?.student_total_tuition_fee) || 0
    } else {
      baseTuitionFee =
        Number(mappedData?.student_monthly_tuition_fee) ||
        Number(mappedData?.student__monthly_tuition_fee) ||
        0
    }
    const TransportRemaining =
      Number(mappedData?.student_transport_fee) - Number(mappedData?.paid_transport_fee)
    const paidTuition =
      Number(mappedData?.paid_tuition_fee) || Number(mappedData?.paid_tution_fee) || 0

    const tuitionRemaining = baseTuitionFee - paidTuition

    const studentExamFee = Number(mappedData?.student_exam_fee) || 0
    const paidExamFee = individualfees ? paidExamFeeSum : Number(mappedData?.paid_exam_fee) || 0
    const examRemaining = studentExamFee - paidExamFee

    return tuitionRemaining + examRemaining + TransportRemaining
  }, [mappedData, individualfees, paidExamFeeSum, isAnually])

  const isOverLimit = totalEntered > remainingBalance
  const discountedFees = mappedData?.student_fee_discount
  const isZeroPayment = totalEntered <= 0
  // console.log('---remainingBalance',remainingBalance);

  const handleInputChange = (fieldName) => (e) => {
    const numericValue = e.target.value.replace(/[^0-9]/g, '')
    formik.setFieldValue(fieldName, numericValue)
  }

  const handleSubmit = async () => {
    if (isOverLimit) {
      toast.error(`Cannot collect more than remaining balance (₹${remainingBalance.toFixed(2)})`)
      return
    }

    if (isZeroPayment) {
      toast.warn('Please enter at least some amount')
      return
    }

    dispatch(setLoader(true))

    try {
      // Validate form values
      await validationSchema.validate(formik.values, { abortEarly: false })

      // Build payload
      const payload = {
        school_id: userSchoolId,
        student_id: studentID,
        last_year_due_fee: formik.values.last_year_due_fee,
        transport_fee: formik.values.transportFee,
        misc_fee: formik.values.miscFee,
        exam_fee: formik.values.exam_fee,
        tuition_fee: formik.values.tuition_fee,
        month: month || rowData?.month,
        payment_id: formik.values.paymentID,
        monthly_discount: formik.values.monthly_discount,
        batch_year: SchoolDInfo?.student_batch_year,
        fee_method: school_fee_method,
      }

      // Only include month when fee method is NOT Annually

      // Get token – fix this line!
      // Most common keys: 'token', 'idtoken', 'access_token', 'authToken'
      // const idtoken = localStorage.getItem('idtoken')

      // if (!idtoken) {
      //   throw new Error('No authentication token found in localStorage')
      // }

      const response = await axios.post(`${baseURL}${urls.ADD_FEE}`, payload)

      // console.log('Fee submission response:', response)

      const status = response?.data?.status

      if (status === 201 || status === 200) {
        toast.success('Fee Added Successfully!')
        dispatch(setRefreshPage(true))
        handleModalClose()
        refetch()
      } else {
        toast.error(response?.data?.message || 'Failed to add fee')
      }
    } catch (error) {
      console.error('Fee submission error:', error)

      if (error.name === 'ValidationError') {
        // Yup validation errors
        error.inner?.forEach((err) => toast.error(err.message))
      } else if (axios.isAxiosError(error)) {
        const msg =
          error.response?.data?.message ||
          error.response?.data?.error ||
          'Server error while adding fee'
        toast.error(msg)
      } else {
        toast.error('Error occurred while submitting')
      }
    } finally {
      dispatch(setLoader(false))
      // You usually don't need refetch() in error case — depends on your logic
      // refetch();   ← only if you want to refresh even on failure
    }
  }

  const handleModalClose = () => {
    formik.resetForm()
    dispatch(setSelectedRow([]))
    handleClose()
  }

  return (
    <ModalWrapper
      open={open}
      handleClose={handleModalClose}
      width={'471px'}
      title={'Confirmation'}
      subtxt={
        'Are you sure you want to collect the fees from the student? Please confirm to proceed.'
      }
    >
      <div>
        <Box mt={2}>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              width: '100%',
            }}
          >
            <Typography fontSize={'18px'} fontWeight={700}>
              Student's Fees
            </Typography>
            {school_fee_method !== 'Annually' && (
              <Typography
                sx={{
                  color: 'var(--Primary-500, #3C45FF)',
                  fontFamily: 'Satoshi',
                  fontSize: '16px',
                  fontWeight: 500,
                  letterSpacing: '0.32px',
                  mb: 1,
                }}
              >
                {month || rowData?.month || '—'}
              </Typography>
            )}
          </div>

          {/* Optional remaining balance display */}
          <Typography
            variant="body2"
            color={isOverLimit ? 'error' : 'text.secondary'}
            sx={{ mt: 1, mb: 1 }}
          >
            Remaining: ₹{remainingBalance.toFixed(2)}
            {isOverLimit && ' → You are exceeding the balance'}
          </Typography>

          <div className="school-info fee-single-info" style={{ marginTop: '10px' }}>
            <Avatar
              alt=""
              sx={{ width: '36px', height: '36px', backgroundColor: '#F2ECF9', color: '#492972' }}
            >
              {studentInfo?.student_name?.[0]?.toUpperCase() || '?'}
            </Avatar>
            <div className="row-item">
              <div>
                <Typography fontWeight={600}>{studentInfo?.student_name || '—'}</Typography>
                <Typography sx={{ color: '#98A1B2', fontSize: '12px' }}>
                  Class: {mappedData?.student_grade || '—'} - {mappedData?.student_section || '—'}
                </Typography>
              </div>
              <Typography sx={{ color: '#039754', fontSize: '16px' }}>
                ₹
                {/* {mappedData?.fee_balance !== undefined
                  ? (individualfees
                      ? parseFloat(mappedData.fee_balance) + paidExamFeeSum - mappedData?.student_exam_fee
                      : parseFloat(mappedData.fee_balance) + mappedData.paid_exam_fee - mappedData?.student_exam_fee
                    )?.toFixed(2)
                  : '0.00'} */}
                {remainingBalance.toFixed(2)}
              </Typography>
            </div>
          </div>
        </Box>

        <div className="text-fields">
          <TextFields
            label={'Payment ID'}
            width={'100%'}
            required
            placeholder={'Pay123'}
            name={'paymentID'}
            value={formik.values.paymentID}
            onChange={formik.handleChange}
          />
          <TextFields
            label={`Tuition Fee (${tuitionBalance})`}
            required
            width={'100%'}
            name={'tuition_fee'}
            value={formik.values.tuition_fee}
            onChange={handleInputChange('tuition_fee')}
          />
        </div>

        <div className="text-fields">
          <TextFields
            label={
              individualfees
                ? `Exam Fee (${mappedData?.student_exam_fee - paidExamFeeSum || 0})`
                : `Exam Fee (${mappedData?.student_exam_fee - mappedData?.paid_exam_fee || 0})`
            }
            width={'100%'}
            name={'exam_fee'}
            value={formik.values.exam_fee}
            onChange={handleInputChange('exam_fee')}
          />
          <TextFields
            label={'Last Year Due'}
            width={'100%'}
            name={'last_year_due_fee'}
            value={formik.values.last_year_due_fee}
            onChange={handleInputChange('last_year_due_fee')}
          />
        </div>

        <div
       
          className="text-fields"
        >
          <TextFields
            label={`Transport Fee (${(mappedData?.student_transport_fee || 0) - mappedData?.paid_transport_fee})`}
            width={'100%'}
            name={'transportFee'}
            value={formik.values.transportFee}
            onChange={handleInputChange('transportFee')}
          />
          {/* <TextFields
            label={'Misc Fee'}
            width={'100%'}
            name={'miscFee'}
            value={formik.values.miscFee}
            onChange={handleInputChange('miscFee')}
          /> */}
          <TextFields
            label={`Discount Fee (${discountedFees || 0})`}
            width={'100%'}
            name={'monthly_discount'}
            value={formik.values.monthly_discount}
            disabled={isAnually}
            onChange={handleInputChange('monthly_discount')}
            hide={true}
          />
        </div>

        <div className="in-a-row" style={{ justifyContent: 'flex-end' }}>
          <Typography className="back-btn" onClick={handleModalClose}>
            Cancel
          </Typography>
          <StyledButton
            width={'40%'}
            onClick={handleSubmit}
            disabled={isOverLimit || isZeroPayment || !formik.values.paymentID.trim()}
            style={{
              backgroundColor: isOverLimit ? '#d32f2f' : undefined,
              color: isOverLimit ? 'white' : undefined,
            }}
          >
            {isOverLimit ? 'Exceeds Balance' : 'Collect Fee'}
          </StyledButton>
        </div>
      </div>
    </ModalWrapper>
  )
}
export const GradeInfo = ({ open, handleClose }) => {
  return (
    <ModalWrapper open={open} handleClose={handleClose} width={'500px'} title={'Class Information'}>
      <div>
        <Typography className="grey-text" fontSize={'18px'} mb={2}>
          Section Information
        </Typography>
        <div className="row-item">
          <Typography fontWeight={500}>Section</Typography>
          <Typography sx={{ fontSize: '14px' }}>A</Typography>
        </div>
      </div>
    </ModalWrapper>
  )
}
